import { AzureLocation } from '../../models/resource-manager';
import { createStringIdAdapter } from './common/string-id-adapter';

export const azureLocationAdapter = createStringIdAdapter<AzureLocation>();
